import { render, staticRenderFns } from "./InvoicesOverview.vue?vue&type=template&id=30a88066"
import script from "./InvoicesOverview.vue?vue&type=script&lang=js"
export * from "./InvoicesOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports